import { Card, Typography, Statistic } from 'antd';

const { Text } = Typography;

const MetricCard = ({ title, subtitle, value, icon, trend, comparison }) => {
    // Handle different value types safely
    const displayValue = typeof value === 'string' ? value : String(value);

    return (
        <Card>
            <Statistic
                title={
                    <>
                        {title}
                        {subtitle && (
                            <Text type="secondary" style={{ display: 'block', fontSize: '0.9em' }}>
                                {subtitle}
                            </Text>
                        )}
                    </>
                }
                value={displayValue}
                valueStyle={{ fontSize: '2em', display: 'flex', alignItems: 'right', textAlign: 'right' }}
            />
            
            {trend && (
                <Text style={{ 
                    color: trend.startsWith('+') ? '#52c41a' : '#f5222d',
                    display: 'block',
                    textAlign: 'right',
                    marginTop: 8
                }}>
                    {trend}
                </Text>
            )}
            
            {comparison && (
                <Text type="secondary" style={{ 
                    display: 'block', 
                    textAlign: 'right',
                    marginTop: 4,
                    fontSize: '0.9em'
                }}>
                    {comparison}
                </Text>
            )}
        </Card>
    );
};

export default MetricCard;